export const AUTHENTICATION_LOAD = 'AUTHENTICATION_LOAD';
export const AUTHENTICATION_LOAD_SUCCESS = 'AUTHENTICATION_LOAD_SUCCESS';
export const AUTHENTICATION_LOAD_ERROR = 'AUTHENTICATION_LOAD_ERROR';
